const config = {
    apiKey: "AIzaSyD9aoqUFLQPXHgjBP5Qi07EwefwkspvSyo",
    authDomain: "easyauth-87504.firebaseapp.com",
    projectId: "easyauth-87504",
    storageBucket: "easyauth-87504.appspot.com",
    messagingSenderId: "776751875062",
    appId: "1:776751875062:web:3baa82e4f5045cf8283dd7"
  };

export default config